import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://gmykgksnbhvaxqaqivnl.supabase.co';
const supabaseKey = 'sb_publishable_0DOA3eN4rIDzOte0Ato3qg_d-UIKXBB';

export const supabase = createClient(supabaseUrl, supabaseKey);
